exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.preview-logo[data-v-1ca1194a] {\n  /* width: 200px; */\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.logo-delete[data-v-1ca1194a] {\n  left: 185px;\n  top: -10px;\n}\n.no-logo-image[data-v-1ca1194a] {\n  width: 200px;\n  height: 200px;\n  text-align: center;\n  border: none;\n  color: var(--border);\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.banner-image[data-v-1ca1194a] {\n  max-height: 160px;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.banner-delete[data-v-1ca1194a] {\n  right: -10px;\n  top: -10px;\n}", ""]);

// exports
